import { useEffect, useState } from "react";
import { Loader2, X, ExternalLink } from "lucide-react";
import { isWaking } from "@/lib/api";

const PROD = process.env.REACT_APP_PRODUCTION_URL;
const isPreview = () => !!PROD && window.location.hostname.endsWith(".preview.emergentagent.com");

// Avviso quando il server sta ripartendo (le richieste vengono ripetute in automatico).
export const ServerWakingBanner = ({ inline = false }) => {
  const [waking, setWaking] = useState(isWaking);
  useEffect(() => {
    const on = (e) => setWaking(!!e.detail);
    window.addEventListener("server-waking", on);
    setWaking(isWaking());
    return () => window.removeEventListener("server-waking", on);
  }, []);
  if (!waking) return null;
  if (inline) return (
    <div className="flex items-center justify-center gap-2 rounded-lg bg-sky-50 dark:bg-sky-950/40 text-sky-700 dark:text-sky-300 text-xs px-3 py-2" data-testid="server-waking-inline">
      <Loader2 className="w-3.5 h-3.5 animate-spin shrink-0" /> Il server si sta avviando, attendi qualche secondo…
    </div>
  );
  return (
    <div className="bg-sky-600 text-white text-xs text-center py-1.5 px-4 flex items-center justify-center gap-2" data-testid="server-waking-banner">
      <Loader2 className="w-3.5 h-3.5 animate-spin shrink-0" /> Connessione al server, attendi qualche secondo…
    </div>
  );
};

// Sul link di anteprima invita ad aprire l'app ufficiale, sempre attiva.
export const PreviewBanner = () => {
  const [hidden, setHidden] = useState(() => sessionStorage.getItem("preview-banner") === "off");
  if (!isPreview() || hidden) return null;
  const close = () => { sessionStorage.setItem("preview-banner", "off"); setHidden(true); };
  return (
    <div className="bg-slate-900 text-white text-xs py-2 px-4 flex items-center gap-3" data-testid="preview-banner">
      <span className="flex-1 min-w-0">Stai usando l'anteprima di prova, che si mette in pausa quando non la usi. L'app ufficiale è sempre attiva.</span>
      <a href={PROD} className="shrink-0 inline-flex items-center gap-1 font-semibold text-orange-300 hover:text-orange-200" data-testid="preview-banner-open-prod">
        Apri l'app <ExternalLink className="w-3.5 h-3.5" />
      </a>
      <button type="button" onClick={close} aria-label="Chiudi" className="shrink-0 opacity-70 hover:opacity-100 p-1 [@media(pointer:coarse)]:p-3 -m-1 [@media(pointer:coarse)]:-my-3" data-testid="preview-banner-close">
        <X className="w-4 h-4" />
      </button>
    </div>
  );
};
